

export default function permission (permission) {
    // permission on user or group
    // belonging to a the user
    console.log('permission', permission)
    return false

    
    // not implemented (yet)


}
